import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";

export default function CardImageViewerSlider({
  setIsImageViewerOpen,
  pictures,
}) {
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const settings = {
    dots: false,
    infinite: true,
    loop: true,
    arrows: true,
    fade: true,
    cssEase: "linear",
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: slider2.current,
    responsive: [
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const settings2 = {
    slidesToShow: 14,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    loop: true,
    focusOnSelect: true,
    asNavFor: slider1.current,
    responsive: [
      {
        breakpoint: 1340,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const closeModal = (e) => {
    if (e.target === e.currentTarget) setIsImageViewerOpen(false);
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      exit={{ opacity: 0 }}
      className="galleryModal"
      onClick={closeModal}
    >
      <div className="galleryModal__close" onClick={closeModal}></div>
      <div className="galleryModal__inner">
        <div className="galleryModal__slider-wrapper">
          <Slider
            {...settings}
            asNavFor={nav2}
            ref={(slider1) => setNav1(slider1)}
            className="galleryModal__slider"
          >
            {pictures?.length > 0 &&
              pictures.map((image, index) => (
                <div key={index} className="gallerySlide">
                  <div className="gallerySlide__inner">
                    <img src={image} alt="" />
                  </div>
                </div>
              ))}
          </Slider>
        </div>
        <Slider
          {...settings2}
          asNavFor={nav1}
          ref={(slider2) => setNav2(slider2)}
          className="galleryModal__swiper"
        >
          {pictures?.length > 0 &&
            [...Array(Math.ceil(14 / pictures.length))]
              .flatMap(() => pictures)
              .slice(0, Math.max(14, pictures.length))
              .map((image, index) => (
                <div key={index} className="gallerySwipe">
                  <div className="gallerySwipe__inner">
                    <img src={image} alt="" />
                  </div>
                </div>
              ))}
        </Slider>
      </div>
    </motion.div>
  );
}
